export type AssertType<T, S> = T extends S ? T : never;
